export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العملة"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إنشاء تقرير"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نتيجة العملة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحميل"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ورقة"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنسيق الملف المسموح به - xlsx"])}
}